export class RegularExpressions {
	public static readonly USPostalCode: RegExp = /^\d{5}(?:[-\s]\d{4})?$/;

	public static readonly CAPostalCode: RegExp = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}\s?\d{1}[A-Z]{1}\d{1}$/;

	public static readonly MXPostalCode: RegExp = /^\d{5}$/;

	public static readonly SpecialCharacters: RegExp = /^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s-#/]*$/;

	public static readonly InternationalPhone: RegExp = /^[0-9\s()-]+$/;

	public static readonly USPhone: RegExp = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

	public static readonly Email: RegExp = /^$|^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;

	public static readonly Website: RegExp = /^(((http|https|HTTP|HTTPS):\/\/)?(www.)?[a-zA-Z0-9._+\-~?&/=]{2,256}\.[a-zA-Z]{2,6}\b([-a-zA-Z0-9.%_+\-~?&/=]*))$|^$/;

	public static readonly SSN: RegExp = /(?=(?=(?=^\d{3}-\d{2}-\d{4}$)^(?!000)(?!666)(?!111-11-1111)(?!222-22-2222)(?!333-33-3333)(?!444-44-4444)(?!555-55-5555)(?!777-77-7777)(?!888-88-8888)(?!999-99-9999)[0-9]{3}-\d{2}-\d{4}$)^\d{3}-(?!00)[0-9]{2}-\d{4}$)^\d{3}-\d{2}-(?!0000)[0-9]{4}$|^XXX-XX-\d{4}$/;

	public static readonly SSNAllMatch: RegExp = /^(\d)(?!\1{8})\d{8}$/;

	public static readonly EmployeeDetailRequest: RegExp = /[^\w]*[/]employments[/][\d]*[/]details$/;

	public static readonly EmploymentsDetailRequest: RegExp = /[^\w]*[/]employments[/][\d]*.json$/;

	public static readonly TerminationDetailRequest: RegExp = /[^\w]*[/]employment[/][\d]*[/]terminations[/]([\d]{4})[-]([\d]{2})-([\d]{2})$/;

	public static readonly TerminationOperationRequest: RegExp = /[^\w]*[/]employment[/]terminations$/;

	public static readonly BillingAccountUE: RegExp = /^[\d]*UE[a-zA-Z0-9]*$/;

	public static readonly StringNotOnlySpaces: RegExp = /^^(?!\s+$).*$/;

	public static readonly PlaceholderPattern: RegExp = /{([A-Za-z_])*}+/g;

	public static readonly TwoWordOnlyTextCharacters: RegExp = /[a-zA-Z-]+[\s]+[a-zA-Z-]+[\s]*$/;

	public static readonly ContactPhone: RegExp = /^(\d{1,40})$/;

	//eslint-disable-next-line
	public static readonly FailedJsDatePattern: RegExp = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
}